/* eslint-disable */
import {settings} from '../../../../helpers/Settings';

const slicer = state => state.data.user;

export const selectExcludeVAT = state => slicer(state).excludeVAT;
export const selectIsLoggedIn = state => slicer(state).isLogged;
export const selectProfile = state => slicer(state).profile ?? {};
export const selectFamilyCardNumber = state => selectProfile(state).familyCardNumber;
export const selectIsProfileEmpty = state => Object.keys(selectProfile(state)).length === 0;
export const selectLatestDeliveryAddress = state => selectProfile(state).latestDeliveryAddress;
export const selectDeliveryAddresses = state => selectProfile(state).deliveryAddresses || [];
export const selectCountryCode = state => selectProfile(state).countryCode || '';
export const selectHasPrimaryAddress = state => Boolean(selectProfile(state).zipCode);
export const selectUserHasMultipleAddresses = state => selectDeliveryAddresses(state).length > 1 || selectHasPrimaryAddress(state) && selectDeliveryAddresses(state).length === 1;
export const selectUserHasAnyAddresses = state => selectHasPrimaryAddress(state) || selectDeliveryAddresses(state).length > 0;

export const selectUseDetailsFlow = state => settings().enable_address_selection_flow
    && selectIsLoggedIn(state)
    && selectCountryCode(state).toLowerCase() === settings().country_code.toLowerCase()
    && selectUserHasAnyAddresses(state);

export const selectShouldTryExpressCheckout = state => settings().express_checkout.enable
    && selectIsLoggedIn(state)
    && !selectUserHasMultipleAddresses(state)
    && selectUserHasAnyAddresses(state);
